export default __webpack_public_path__ + "static/community_event_2-9a20b465dc676feabea50f83ac6b0c68.jpg";